import { FC, useRef, useEffect } from "react";
import styles from "./ColorPickerPopup.module.css";

const COLORS = [
  "#ef4444", "#f97316", "#eab308", "#22c55e",
  "#14b8a6", "#3b82f6", "#8b5cf6", "#ec4899",
  "#ffffff", "#94a3b8", "#475569", "#1e293b",
];

interface Props {
  color: string;
  onChange: (color: string) => void;
  onClose: () => void;
}

export const ColorPickerPopup: FC<Props> = ({ color, onChange, onClose }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        document.addEventListener("click", (ce) => ce.stopPropagation(), { capture: true, once: true });
        onClose();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  return (
    <div ref={ref} className={styles.popup}>
      <span className={styles.title}>Line color</span>
      <div className={styles.grid}>
        {COLORS.map((c) => (
          <button
            key={c}
            className={`${styles.swatch} ${c === color ? styles.selected : ""}`}
            style={{ background: c }}
            onClick={() => onChange(c)}
          />
        ))}
      </div>
    </div>
  );
};
